import { call, select, put, takeLatest } from 'redux-saga/effects';
import _get from 'lodash/get';
import * as actions from '../actions';
import { ADD_CAR_PROCESS_REQUEST } from '../types';
import { addCarProcessApi } from '../api';

export function* addCarProcessRequestSaga() {
  try {
    const {
      root: {
        addCar: {
          vinCheck: { vin, thirdParty },
          registrationInfo,
          uploadDocuments: { documents },
        },
      },
      Data: { csrfToken, reCaptchaSiteKey },
    } = yield select();

    const actionName = 'addCarProcess';
    const recaptchaToken = reCaptchaSiteKey
      ? yield window.grecaptcha.execute(reCaptchaSiteKey, {
          action: actionName,
        })
      : '';

    const addCarData = {
      vin,
      ...registrationInfo,
      locations: [],
      countryCode: registrationInfo.countryName,
      purchasedFrom3rdParty: thirdParty,
      uploadedDocuments: documents,
      recaptchaToken: { actionName, tokenId: recaptchaToken },
    };

    const {
      data: { success, data },
    } = yield call(addCarProcessApi, csrfToken, addCarData);
    const { ProcessedInstantTransfer, processedInstantTransfer } = data;
    if (!success) {
      yield put(actions.addCarProcessFailure(data));
    } else {
      yield put(actions.addCarProcessSuccess(ProcessedInstantTransfer || processedInstantTransfer));
    }
  } catch (e) {
    yield put(actions.addCarProcessFailure(_get(e, 'response.data.data')));
  }
}

const addCarProcessSaga = [takeLatest(ADD_CAR_PROCESS_REQUEST, addCarProcessRequestSaga)];

export default addCarProcessSaga;
